/**
 * lib/robots-meta — SPA-страховка `<meta name="robots" content="noindex">` на
 * ИГРОВЫХ app-поверхностях (SEO-хардинг, owner 2026-06-19).
 *
 * ЗАЧЕМ / WHY THIS EXISTS: игровые app-пути (`/play`,`/daily`,`/leaderboard`,
 * `/profile`,`/workshop`,`/gnomes`) НЕ должны индексироваться (интерактивные
 * поверхности = тонкие дубли контент-страниц). Авторитетный механизм — серверный
 * (`robots.txt` Disallow + Caddy `X-Robots-Tag`, deploy-док). Этот модуль —
 * BEST-EFFORT СТРАХОВКА для JS-исполняющих краулеров (Googlebot рендерит SPA):
 * при показе игровой фазы ставит `<meta name="robots" content="noindex">`, при
 * возврате на КОНТЕНТ/ЛЕНДИНГ — СНИМАЕТ его (контент обязан индексироваться). Один
 * источник списка app-путей — shared `APP_ROUTE_PATHS` (тот же, что robots/Caddy),
 * через `isAppRoutePath` — robots.txt, meta и Caddy не разъедутся.
 *
 * Почему по URL, а не по фазе: единый предикат `isAppRoutePath(location.pathname)`
 * совпадает 1-в-1 с тем, что Disallow'ит robots — никакого второго маппинга
 * «фаза→indexable» (он мог бы разойтись с robots). Зовётся на каждую смену URL
 * (boot + phase-sync + popstate).
 *
 * SCOPE: создать/обновить/снять ОДИН `<meta name="robots">` в `<head>` по текущему
 *   pathname. Идемпотентно. Vanilla DOM. NOT IN SCOPE: маппинг path↔phase
 *   (lib/game-routing), серверный X-Robots-Tag (Caddy, deploy-док), список app-путей
 *   (shared/config/app-routes).
 *
 * Cross-references: ADR-0021 addendum-001 §C / deploy-серв-слой-док (X-Robots-Tag);
 *   `@lines98/shared/config/app-routes` (`isAppRoutePath`); app.ts (вызовы).
 */

import { isAppRoutePath } from '@lines98/shared/config/app-routes';

/** id атрибут нашего управляемого meta-тега (чтобы не плодить дубликаты). */
const ROBOTS_META_ID = 'spa-robots-noindex';

/**
 * Привести `<meta name="robots" content="noindex">` в соответствие текущему пути:
 * игровой app-путь → тег ПРИСУТСТВУЕТ (noindex); контент/лендинг/реплей → тег СНЯТ
 * (страница индексируема). Идемпотентно — безопасно звать на каждую смену URL.
 * `pathname` по умолчанию = `window.location.pathname` (caller может передать явно).
 */
export function syncRobotsMeta(pathname: string = window.location.pathname): void {
  if (typeof document === 'undefined') return;
  const existing = document.getElementById(ROBOTS_META_ID) as HTMLMetaElement | null;
  const wantNoindex = isAppRoutePath(pathname);

  if (wantNoindex) {
    if (existing) return; // уже стоит — no-op
    const meta = document.createElement('meta');
    meta.id = ROBOTS_META_ID;
    meta.name = 'robots';
    meta.content = 'noindex';
    document.head.appendChild(meta);
  } else if (existing) {
    // Вернулись на индексируемую поверхность (контент/лендинг) — снять noindex.
    existing.remove();
  }
}
